<template>
    <div class="containerInner">
        <div class="listHeader">
            <div class="headerLeftMenu">
                <span>表示条件</span>
                <span>
                    <select v-model="searchServiceId">
                        <option value="">全店舗</option>
                        <option v-for="service in filteredService()" :value="service.id" v-bind:key="service.id">
                            （{{ service.id }}）{{ service.name }}</option>
                    </select>
                </span>

                <span>
                    <a class="btn searchBtn" @click="searchItem">検索</a>
                </span>

                <span>
                    <a class="btn clearBtn" @click="searchClear">条件クリア</a>
                </span>
            </div>
        </div>


        <div class="AdWrapper">
            <div class="AdTab">
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 0 }"
                    @click="showFacebook">Facebook広告</button>
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 1 }"
                    @click="showFacebookDynamic">Facebookダイナミック広告</button>
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 2 }"
                    @click="showYahooSearch">Yahoo検索広告</button>
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 3 }"
                    @click="showYahooDisplay">Yahooディスプレイ広告</button>
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 4 }"
                    @click="showGoogle">Google広告</button>
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 5 }"
                    @click="showGoogleShopping">Googleショッピング広告</button>
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 6 }"
                    @click="showGooglePmax">GoogleP-MAX広告</button>
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 7 }"
                    @click="showGoogleDemandGen">Googleデマジェネ広告</button>
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 8 }"
                    @click="showLine">LINE広告</button>
                <button class="AdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 9 }"
                    @click="showMicrosoft">Microsoft広告</button>
            </div>
            <div class="table-container">
                <div class="pdt">

                    <template v-for="(service, serviceId) in this.ads">
                        <div class="wrap" :key="serviceId">
                            <h1>{{ service['date']['name'] }}</h1>

                            <template v-for="(campaign, campaignId) in service">
                                <div v-if="campaignId !== 'date'" :key="campaignId" style="margin-bottom: 30px;">

                                    <table id="CampaignTable">
                                        <tr>
                                            <td class="w_Name">{{ campaign['date']['name'] }}</td>
                                            <td v-if="campaign['date']['status'] == 'ACTIVE'">有効</td>
                                            <td v-else-if="campaign['date']['status'] == 'ENABLED'">有効</td>
                                            <td v-else-if="campaign['date']['status'] == 'PAUSED'">停止</td>
                                            <td v-else-if="campaign['date']['status'] == 'REJECTED'">却下</td>
                                            <td v-else-if="campaign['date']['status'] == 'REMOVED'">削除</td>
                                            <td v-else-if="campaign['date']['status'] == null">削除</td>
                                            <td v-else>
                                                {{ campaign['date']['status'] }}
                                            </td>
                                        </tr>
                                    </table>


                                    <template v-for="(adgroup, adgroupId) in campaign">
                                        <dl v-if="adgroupId !== 'date'" class="toggle_contents_other toggle_ad_group"
                                            :key="adgroupId">
                                            <dt class="toggle_title_other" @click="toggle_adgroup(adgroupId)"
                                                v-bind:class="{ 'selected': isSelectedAdgroup === adgroupId }">

                                                <table id="AdGroupTable">
                                                    <tr>
                                                        <td class="w_Name">{{ adgroup['date']['name'] }}</td>
                                                        <td v-if="adgroup['date']['status'] == 'ACTIVE'">有効</td>
                                                        <td v-else-if="adgroup['date']['status'] == 'ENABLED'">有効</td>
                                                        <td v-else-if="adgroup['date']['status'] == 'PAUSED'">停止</td>
                                                        <td v-else-if="adgroup['date']['status'] == 'REJECTED'">却下</td>
                                                        <td v-else-if="adgroup['date']['status'] == 'REMOVED'">削除</td>
                                                        <td v-else-if="adgroup['date']['status'] == null">削除</td>
                                                        <td v-else>
                                                            {{ adgroup['date']['status'] }}
                                                        </td>
                                                    </tr>
                                                </table>

                                                <span class="toggle_btn_other"></span>
                                            </dt>

                                            <dd v-if="privateAdTabActive != 0 && privateAdTabActive != 8"
                                                class="ad-list" v-show="isSelectedAdgroup === adgroupId">
                                                <table id="AdTable">
                                                    <template v-for="(ad, adId) in adgroup">
                                                        <tr v-if="adId !== 'date'" :key="adId">
                                                            <td class="w_adName">{{ ad['date']['name'] }}</td>
                                                            <td style="width: 10%;" class="ta-c"
                                                                v-if="ad['date']['status'] == 'ACTIVE'">有効</td>
                                                            <td style="width: 10%;" class="ta-c"
                                                                v-else-if="ad['date']['status'] == 'ENABLED'">有効</td>
                                                            <td style="width: 10%;" class="ta-c"
                                                                v-else-if="ad['date']['status'] == 'PAUSED'">停止</td>
                                                            <td style="width: 10%;" class="ta-c"
                                                                v-else-if="ad['date']['status'] == 'REJECTED'">却下</td>
                                                            <td style="width: 10%;" class="ta-c"
                                                                v-else-if="ad['date']['status'] == 'REMOVED'">削除</td>
                                                            <td style="width: 10%;" class="ta-c"
                                                                v-else-if="ad['date']['status'] == null">削除</td>
                                                            <td style="width: 10%;" class="ta-c" v-else>
                                                                {{ ad['date']['status'] }}
                                                            </td>
                                                            <td class="w_url">
                                                                <a :href="ad['date']['url']" target="_blank">
                                                                    {{ ad['date']['url'] }}
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </dd>

                                            <!-- Facebook広告の場合 -->
                                            <!-- LINE広告の場合 -->
                                            <dd v-else class="ad-list" v-show="isSelectedAdgroup === adgroupId">
                                                <table id="AdTable">
                                                    <template v-for="(ad, adId) in adgroup">
                                                        <template v-if="adId !== 'date'">
                                                            <template v-for="(url, no) in ad['date']['url']">
                                                                <tr :key="no">
                                                                    <template v-if="no == 0">
                                                                        <td class="w_adName">{{
                                                                            ad['date']['name'] }}</td>
                                                                        <td style="width: 10%;" class="ta-c"
                                                                            v-if="ad['date']['status'] == 'ACTIVE'">有効
                                                                        </td>
                                                                        <td style="width: 10%;" class="ta-c"
                                                                            v-else-if="ad['date']['status'] == 'ENABLED'">
                                                                            有効
                                                                        </td>
                                                                        <td style="width: 10%;" class="ta-c"
                                                                            v-else-if="ad['date']['status'] == 'PAUSED'">
                                                                            停止
                                                                        </td>
                                                                        <td style="width: 10%;" class="ta-c"
                                                                            v-else-if="ad['date']['status'] == 'REJECTED'">
                                                                            却下
                                                                        </td>
                                                                        <td style="width: 10%;" class="ta-c"
                                                                            v-else-if="ad['date']['status'] == 'REMOVED'">
                                                                            削除
                                                                        </td>
                                                                        <td style="width: 10%;" class="ta-c"
                                                                            v-else-if="ad['date']['status'] == null">削除
                                                                        </td>
                                                                        <td style="width: 10%;" class="ta-c" v-else>
                                                                            {{ ad['date']['status'] }}
                                                                        </td>
                                                                    </template>

                                                                    <template v-else>
                                                                        <td class="w_adName ta-c">〃</td>
                                                                        <td class="ta-c">〃</td>
                                                                    </template>

                                                                    <td class="w_url">
                                                                        <a :href="url" target="_blank">
                                                                            {{ url }}
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </table>
                                            </dd>
                                        </dl>
                                    </template>

                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>

        </div>

        <div class="loading-window" v-show="this.$store.state.loading">
            <div class="loading-window-inner">
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PrivateAdStatus',
    data() {
        return {
            privateAdTabActive: 0,
            ads: [],
            createMode: false,
            selectedId: null,
            services: {},
            searchServiceId: "",
            isSelectedCampaign: 0,
            isSelectedAdgroup: 0,
        }
    },
    mounted: function () {
        //初回表示は「facebook広告」
        this.fetchFacebookAds();

        //サービス名プルダウンセット
        this.getServiceId();
    },
    methods: {
        //オープン
        toggle_campaign(target) {
            this.isSelectedAdgroup = 0;

            if (this.isSelectedCampaign !== target) {
                this.isSelectedCampaign = target;
            }
            else {
                this.isSelectedCampaign = 0;
            }
        },
        toggle_adgroup(target) {
            if (this.isSelectedAdgroup !== target) {
                this.isSelectedAdgroup = target;
            }
            else {
                this.isSelectedAdgroup = 0;
            }
        },
        //facebook広告
        fetchFacebookAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateFacebookAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //facebookダイナミック広告
        fetchFacebookDynamicAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateFacebookDynamicAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //Yahoo検索広告
        fetchYahooSearchAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateYahooSearchAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //Yahooディスプレイ広告
        fetchYahooDisplayAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateYahooDisplayAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //Google広告
        fetchGoogleAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateGoogleAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //Googleショッピング広告
        fetchGoogleShoppingAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateGoogleShoppingAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //GooglePmax広告
        fetchGooglePmaxAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateGooglePmaxAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //Googleデマジェネ広告
        fetchGoogleDemandGenAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateGoogleDemandGenAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //Line広告
        fetchLineAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateLineAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //Microsoft広告
        fetchMicrosoftAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateMicrosoftAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //検索
        searchItem: function () {
            this.$store.dispatch("loading", true);
            this.currentPage = 1;

            //Facebook広告
            if (this.privateAdTabActive == 0) {
                this.axios.get("/api/privateFacebookAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }

            //Facebookダイナミック広告
            if (this.privateAdTabActive == 1) {
                this.axios.get("/api/privateFacebookDynamicAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }

            //Yahoo検索広告
            if (this.privateAdTabActive == 2) {
                this.axios.get("/api/privateYahooSearchAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }

            //Yahooディスプレイ広告
            if (this.privateAdTabActive == 3) {
                this.axios.get("/api/privateYahooDisplayAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }

            //Google広告
            else if (this.privateAdTabActive == 4) {
                this.axios.get("/api/privateGoogleAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }

            //Googleショッピング広告
            else if (this.privateAdTabActive == 5) {
                this.axios.get("/api/privateGoogleShoppingAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }

            //GooglePmax広告
            else if (this.privateAdTabActive == 6) {
                this.axios.get("/api/privateGooglePmaxAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }

            //Googleデマジェネ広告
            else if (this.privateAdTabActive == 7) {
                this.axios.get("/api/privateGoogleDemandGenAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }

            //LINE広告
            else if (this.privateAdTabActive == 8) {
                this.axios.get("/api/privateLineAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }

            //Microsoft広告
            else if (this.privateAdTabActive == 9) {
                this.axios.get("/api/privateMicrosoftAds/?page=1", { params: { searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = res.data;
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }
        },
        //条件クリア
        searchClear: function () {
            this.searchServiceId = "";
        },
        //Facebook広告
        showFacebook: function () {
            this.privateAdTabActive = 0;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchFacebookAds();
        },

        //Facebookダイナミック広告
        showFacebookDynamic: function () {
            this.privateAdTabActive = 1;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchFacebookDynamicAds();
        },

        //Yahoo検索広告タブがクリックされた場合
        showYahooSearch: function () {
            this.privateAdTabActive = 2;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchYahooSearchAds();
        },
        //Yahooディスプレイ広告タブがクリックされた場合
        showYahooDisplay: function () {
            this.privateAdTabActive = 3;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchYahooDisplayAds();
        },
        //Google広告タブ
        showGoogle: function () {
            this.privateAdTabActive = 4;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchGoogleAds();
        },
        //Googleショッピング広告タブ
        showGoogleShopping: function () {
            this.privateAdTabActive = 5;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchGoogleShoppingAds();
        },
        //GooglePmax広告タブ
        showGooglePmax: function () {
            this.privateAdTabActive = 6;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchGooglePmaxAds();
        },
        //Googleデマジェネ広告タブ
        showGoogleDemandGen: function () {
            this.privateAdTabActive = 7;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchGoogleDemandGenAds();
        },
        //LINE広告
        showLine: function () {
            this.privateAdTabActive = 8;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchLineAds();
        },
        //Microsoft広告タブ
        showMicrosoft: function () {
            this.privateAdTabActive = 9;
            this.ads = [];
            this.searchServiceId = "";
            this.fetchMicrosoftAds();
        },
        //サービスIDの一覧取得
        getServiceId: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/service/")
                .then((res) => {
                    this.services = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        filteredService() {
            let result = [];
            let list = [30, 33, 35];

            for (var idx in this.services) {
                let service = this.services[idx];
                if (list.includes(service.id)) {
                    result.push(service);
                }
            }
            return result;
        },
    },
}
</script>

<style scoped lang="sass">
.containerInner
    overflow: hidden
    .loading-window
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loading-window-inner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
    .listHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 50%
            span
                display: inline-block
                vertical-align: middle
                .searchInputText
                    margin-left: 20px
                    padding: 10px
                    width: 200px
                    &:focus
                        outline: 2px solid $mainColor
                .searchBtn
                    border: 1px solid $mainColor
                    margin: 0 20px 0 10px
                    padding: 12px
                    width: 60px
                    &:hover
                        border: 1px solid $mainColor
                .clearBtn
                    border: 1px solid $mainColor
                    margin: 0
                    padding: 12px
                    width: 100px
                    &:hover
                        border: 1px solid $mainColor
                select
                    margin-left: 15px
                    padding: 10px
                    width: 280px
    .AdWrapper
        margin: 0 140px
    .AdTab
        display: flex
        align-items: flex-end
        gap: 1px
        .AdTabBtn
            display: flex
            justify-content: center
            align-items: center
            width: 170px
            height: 30px
            border: none
            background: #C0C0C0
            border-radius: 5px 5px 0 0
            color: #FFF
            font-size: 1.2rem
            cursor: pointer
            &.active
                height: 38px
                background: $grayColor
    .table-container
        max-height: 75vh;
        overflow-y: auto;
        &::-webkit-scrollbar
            width: 4px
            border-radius: 2px
            background-color: #c0c0c0
        &::-webkit-scrollbar-thumb
            border-radius: 2px
            background-color: $mainColor
        .pdt
            width: 100%
            height: 90%;
            .wrap
                margin-top: 10px;
                margin-bottom: 50px;
            h1
                font-size: 20px;
                font-weight: 900;
            .toggle_contents_other
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 100%;
                padding: 0;
                font-size: 16px;
            .toggle_ad_group
                .toggle_title_other
                    position: relative;
                    width: 100%;
                    height: 45px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border: 1px solid #fff;
                    background: #9ecf97;
                dd
                    width: 100%;
            .toggle_btn_other
                position: absolute;
                top: 50%;
                right: 15px;
                transform: translateY(-50%);
                display: block;
                width: 20px;
                height: 20px;
                transition: all 0.3s ease;
                &:before
                    display: block;
                    content: "";
                    background-color: #fff;
                    position: absolute;
                    width: 3px;
                    height: 1.4vw;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    transition: 0.3s;
                &:after
                    display: block;
                    content: "";
                    background-color: #fff;
                    position: absolute;
                    width: 1.4vw;
                    height: 3px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    transition: 0.3s;
            .toggle_title_other.selected .toggle_btn_other
                position: absolute;
                top: 50%;
                right: 15px;
                transform: translateY(-50%) rotate(90deg);
            .toggle_title_other.selected .toggle_btn_other:after
                content: normal;
        .w_Name
            width: 33%;
        .w_adName
            width: 30%;
        .w_url
            width: 60%;
        .ta-c
            text-align: center;
    #CampaignTable
        position: relative
        z-index: 1
        width: 100%
        table-layout: fixed;
        border-collapse: separate
        margin: 0px auto
        font-size: 16px;
        td
            padding: 10px 15px 5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
    #AdGroupTable
        position: relative
        z-index: 1
        width: 100%
        table-layout: fixed;
        border-collapse: separate
        margin: 0px auto
        font-size: 16px;
        td
            padding: 10px 15px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
    #AdTable
        position: relative
        z-index: 1
        width: 100%
        table-layout: fixed;
        border-collapse: separate
        margin: 0px auto
        td
            border: 1px solid #D6D885;
            padding: 10px 15px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
@include sp()
    .containerInner
        .listHeader
            display: block
            margin: 20px 0 0 10px
        .AdWrapper
            margin: 20px 0 0
        .AdTab
            display: block;
            .AdTabBtn
                display: inline;
        .table-container
            .pdt
                .toggle_btn_other
                    &:before
                        width: 3px;
                        height: 3.4vw;
                    &:after
                        width: 3.4vw;
                        height: 3px;
                .toggle_contents_other
                    font-size: 12px;
            .w_Name
                width: 70%;
            .w_adName
                width: 50%;
            .w_url
                width: 40%;
        #CampaignTable
            font-size: 12px;
        #AdGroupTable
            font-size: 12px;
        #AdTable
            td
                padding: 5px;
</style>
